export default "__VITE_ASSET__CfHlSx9R__"